import { createStore } from 'satcheljs';

export interface PublishedCalendarLeftPaneStore {
    isLeftPaneExpanded: boolean;
}

const publishedCalendarLeftPaneStore: PublishedCalendarLeftPaneStore = {
    isLeftPaneExpanded: false,
};

export const getPublishedCalendarLeftPaneStore = createStore<PublishedCalendarLeftPaneStore>(
    'publishedCalendarLeftPaneStore',
    publishedCalendarLeftPaneStore
);
